import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/media";
import SectionHeading from "@/components/feature/SectionHeading";

interface NewsSectionProps {
  items: NewsItem[];
}

export default function NewsSection({ items }: NewsSectionProps) {
  const [lead, ...rest] = items;
  if (!lead) return null;

  return (
    <section className="mx-auto mt-14 w-full px-4 md:px-6">
      <SectionHeading
        title="影视资讯精选"
        subtitle="最新影视新闻、行业观察与深度影评"
        icon="ri-newspaper-line"
        moreTo="/news"
        moreLabel="全部资讯"
      />

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
        <Link
          to={`/news/${lead.id}`}
          className="group relative block overflow-hidden rounded-lg bg-primary-950"
        >
          <div className="relative h-64 w-full md:h-full md:min-h-[340px]">
            <img
              src={lead.cover}
              alt={`${lead.title} 资讯配图`}
              title={`${lead.title} 影视资讯`}
              className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/95 via-primary-950/40 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <span className="inline-block rounded-md bg-accent-500 px-2 py-0.5 text-xs font-medium text-white">
                {lead.category}
              </span>
              <h3 className="mt-3 font-heading text-lg font-bold leading-snug text-white md:text-xl">
                {lead.title}
              </h3>
              <p className="mt-2 hidden text-sm leading-relaxed text-white/70 sm:block">
                {lead.summary}
              </p>
              <p className="mt-3 text-xs text-white/60">{lead.date}</p>
            </div>
          </div>
        </Link>

        <ul className="flex flex-col gap-3">
          {rest.slice(0, 5).map((item) => (
            <li key={item.id}>
              <Link
                to={`/news/${item.id}`}
                className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-accent-300"
              >
                <span className="flex h-16 w-24 shrink-0 overflow-hidden rounded-md bg-background-100">
                  <img
                    src={item.cover}
                    alt={`${item.title} 资讯配图`}
                    title={`${item.title} 影视资讯`}
                    className="h-full w-full object-cover object-center"
                  />
                </span>
                <span className="flex min-w-0 flex-1 flex-col">
                  <span className="line-clamp-2 text-sm font-medium text-foreground-900 group-hover:text-accent-600">
                    {item.title}
                  </span>
                  <span className="mt-2 flex items-center gap-3 text-xs text-secondary-500">
                    <span className="rounded bg-secondary-100 px-2 py-0.5 text-secondary-700">
                      {item.category}
                    </span>
                    {item.date}
                  </span>
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}